export function isIOSSafari() {
  if (typeof navigator === 'undefined') return false;
  var ua = navigator.userAgent;
  var iOS =
    /iP(hone|od|ad)/i.test(ua) || (ua.indexOf('Mac') > -1 && 'ontouchend' in window);
  var isWebKit = /WebKit/i.test(ua);
  // iOS + WebKit + pas Chrome/Firefox/Edge iOS => Safari iOS
  return iOS && isWebKit;
}
